import { useState, useEffect } from "react";
import axios from "../lib/api";
import { API } from "../App";
import { Card, CardContent } from "../components/ui/card";

export default function AdminSyncLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${API}/admin/sync-logs?limit=50`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setLogs(r.data.logs))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-sync-logs">
      <h1 className="text-2xl font-semibold text-slate-900">Sync Logs</h1>

      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-100 bg-slate-50/50">
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Tipo</th>
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Org ID</th>
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Estado</th>
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Sync Type</th>
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Última sync</th>
                  <th className="text-left px-4 py-3 font-medium text-slate-500">Error</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={6} className="text-center py-8 text-slate-400">Cargando...</td></tr>
                ) : logs.length === 0 ? (
                  <tr><td colSpan={6} className="text-center py-8 text-slate-400">Sin logs de sincronización</td></tr>
                ) : logs.map((log, i) => (
                  <tr key={i} className="border-b border-slate-50 hover:bg-slate-50/50">
                    <td className="px-4 py-3">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                        log.sync_type_label === "products" ? "bg-blue-100 text-blue-700" : "bg-green-100 text-green-700"
                      }`}>
                        {log.sync_type_label}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs text-slate-600">{log.organization_id || "-"}</td>
                    <td className="px-4 py-3">
                      <span className={`text-xs ${log.status === "completed" ? "text-green-600" : log.status === "failed" ? "text-red-600" : "text-slate-500"}`}>
                        {log.status || "-"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-600">{log.sync_type || log.last_sync_type || "-"}</td>
                    <td className="px-4 py-3 text-xs text-slate-500">
                      {log.last_sync || log.synced_at || "-"}
                    </td>
                    <td className="px-4 py-3 text-xs text-red-500 max-w-xs truncate">{log.last_error || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
